import React, { useEffect, useState } from "react";
import CardTeny from "../../../components/Card/CardTenyzaraina/CardTeny";
import * as TenyZarainaService from "../../../services/TenyZarainaService";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import "./show.scss";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Spinner from "../../../components/Spinner/Spinner";
import SearchBar from "../../../components/Search/SearchBar";

const ShowTenyZarainaPage = () => {
  const [tenyzaraina, setTenyzaraina] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    TenyZarainaService.getAllTenyZaraina()
      .then((tenyzarainas) => {
        const sortedTenyZaraina = tenyzarainas.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTenyzaraina(sortedTenyZaraina);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Erreur lors du chargement des données Teny Zaraina :",
          error
        );
        setIsLoading(false);
      });
  }, []);

  const handleDelete = async (id) => {
    const isConfirmed = await Swal.fire({
      title: "Êtes-vous sûr de vouloir supprimer cette chanson ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer!",
      cancelButtonText: "Annuler",
    });

    if (isConfirmed.isConfirmed) {
      try {
        const response = await TenyZarainaService.deleteTenyZarainaById(id);
        if (response && response.status === 200) {
          Swal.fire(
            "Teny Zaraina supprimé !",
            "Suppression réussie",
            "success"
          );
          let newTeny = tenyzaraina.filter((vavakas) => vavakas.id !== id);
          setTenyzaraina(newTeny);
        } else {
          Swal.fire("Erreur", "La suppression a échoué", "error");
        }
      } catch (error) {
        console.error("Erreur lors de la suppression du teny zaraina :", error);
        Swal.fire("Erreur", "Une erreur s'est produite", "error");
      }
    }
  };

  const handleSearch = (value) => {
    setFilterTitle(value);
  };

  return (
    <div className="tenyZaraina-component">
      <div className="bouton-add">
        <Link to="/tenyzaraina/addTenyzaraina">
          <Button>Créer Teny Zaraina</Button>
        </Link>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "15px",
        }}
      >
        <SearchBar onSearch={handleSearch} />
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="tenyZaraina">
          {Array.isArray(tenyzaraina) && tenyzaraina.length > 0 ? (
            tenyzaraina
              .filter((tenyzarainas) =>
                tenyzarainas.title
                  .toLowerCase()
                  .includes(filterTitle.toLowerCase())
              )
              .map((tenyzarainas) => (
                <CardTeny
                  key={tenyzarainas.id}
                  tenyzarainas={tenyzarainas}
                  handleDelete={() => handleDelete(tenyzarainas.id)}
                />
              ))
          ) : (
            <Typography variant="h6">Il n'y a pas de Teny zaraina.</Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowTenyZarainaPage;
